// 渲染音频文件和共享
import React, { memo, useState, useEffect } from 'react'
import styled from 'styled-components'
import VoiceImg from "@/img/voice.png";
import DownloadImg from "@/img/download-img-color.png";
import playIngImg from '@/img/play_icon.gif'
import BenzAMRRecorder from 'benz-amr-recorder'

const VoiceMsgOrd = styled.span`
  display: inline-block;
  margin-top: 8px;
  padding: 16px;
  background: #E9E9E9;
  border-radius: 8px;
  color: #595959;

  .top-div{
    display: flex;
    align-items: center;
    margin-bottom: 8px;
    height: 20px;
    line-height: 20px;

    &:last-child {
      margin-bottom: 0px;
    }

    img{
      width: 16px;
      height: 16px;
      cursor: pointer;
    }

    span{
      margin: 0 8px;
    }
  }
`

const RenderVoiceCallMsg = memo((props) => {
  const { value, renderType } = props
  const [message, setMessage] = useState({})
  const [activeId, setActiveId] = useState('')
  const [playing, setPlaying] = useState(false)

  //将秒换算成时和分
  const formateSeconds = (endTime) => {
    let secondTime = parseInt(endTime)//将传入的秒的值转化为Number
    let min = 0// 初始化分
    let h = 0// 初始化小时
    let result = ''
    if (secondTime > 60) {//如果秒数大于60，将秒数转换成整数
      min = parseInt(secondTime / 60)//获取分钟，除以60取整数，得到整数分钟
      secondTime = parseInt(secondTime % 60)//获取秒数，秒数取佘，得到整数秒数
      if (min > 60) {//如果分钟大于60，将分钟转换成小时
        h = parseInt(min / 60)//获取小时，获取分钟除以60，得到整数小时
        min = parseInt(min % 60) //获取小时后取佘的分，获取分钟除以60取佘的分
      }
    }
    result = `${h.toString().padStart(2, '0')}:${min.toString().padStart(2, '0')}:${secondTime.toString().padStart(2, '0')}`
    return result
  }

  // 下载
  const downloadImg = (url, name) => {
    name = name || url;
    // fetch抓取图片数据
    fetch(url)
      .then((response) => {
        if (response.status === 200)
          // 返回的.blob()为promise，然后生成了blob对象，此方法获得的blob对象包含了数据类型，十分方便
          return response.blob();
        throw new Error(`status: ${response.status}.`);
      })
      .then((blob) => {
        // 获取到blob对象
        downloadFile(name, blob);
      })
      .catch(() => { });
    function downloadFile(fileName) {
      const anchor = document.createElement("a");
      // 创建指向blob对象地址
      anchor.href = fileName;
      document.body.appendChild(anchor);
      anchor.click();
    }
  };

  useEffect(() => {
    let arr = value.messageContent ? JSON.parse(value.messageContent) : {}
    setMessage(arr)
    return () => {
      if(window.amrPlay) {
        window.amrPlay.stop()
        window.amrPlay = null
        return
      }
    }
  }, [])

  const renderId = `${renderType}_${props.value.id}`

  const pause = () => {
    window.amrPlay.pause()
    setPlaying(false)
  }

  const play = (e) => {
    const messageContent = props?.value?.messageContent
    try{
      const messageContentValue = JSON.parse(messageContent) || {}
      const { url } = messageContentValue
      if(window.amrPlayId === renderId) {
        if(playing) {
          pause()
        }
        else {
          let time = window?.amrPlay?.getDuration()
          const pauseTime = window?.amrPlay?._pauseTime
          window.amrPlay?.play((time - pauseTime < 1) ? 0 : pauseTime)
          setActiveId(renderId)
          setPlaying(true)
          window.amrPlayId = renderId
        }
        return
      }
      if(window.amrPlay) {
        // https://www.npmjs.com/package/benz-amr-recorder 不支持旧的对象内部实现更换音频
        window.amrPlay.stop()
        window.amrPlay = null
        play(e)
        return
      }
      window.amrPlay = new BenzAMRRecorder()
      window.amrPlay.initWithUrl(url).then(() => {
        amrPlay.play()
        setPlaying(true)
        setActiveId(renderId)
        window.amrPlayId = renderId
      })
      window.amrPlay.onStop(() => {
        setActiveId('')
      })
    }
    catch(err) {
      console.log(err, '播放失败')
    }
  }

  return (
    <VoiceMsgOrd>
      <div className="top-div">
        <img src={(activeId === renderId && playing) ? playIngImg : VoiceImg} alt="" onClick={play} />
        <span>
          {formateSeconds(message.playLength)}
        </span>
        <img src={DownloadImg} alt="" onClick={() => {
          downloadImg(message.url);
        }} />
      </div>
    </VoiceMsgOrd>
  )
})

export default RenderVoiceCallMsg
